import React, { useEffect } from 'react';
import { BrandHeader } from '../components/BrandHeader';
import { OrangeAccent } from '../components/OrangeAccent';
import { PageTransition } from '../components/PageTransition';
import { WistiaPlayer } from '../components/WistiaPlayer';
import { ClientResults } from '../components/ClientResults';
const FAQS: {
  q: string;
  mediaId: string;
}[] = [{
  q: 'How the 90-Day Guarantee & Pricing Actually Work',
  mediaId: 'szc8ug5vxc'
}, {
  q: 'Who This Is For (And Not For)',
  mediaId: 'blpam09o4c'
}, {
  q: 'What Happens On Your Install Call (And How To Prepare)',
  mediaId: 'f7lfvh7psy'
}, {
  q: 'Will This Just Create More Work For Me Or My Front Desk?',
  mediaId: 'mw7jw3fx9t'
}, {
  q: 'What If I Already Have Vendors? Do I Have To Let Them Go?',
  mediaId: 'n5foh6m2w7'
}, {
  q: "How Fast Can I Expect Results & What Happens If It Doesn't Work?",
  mediaId: '1ruxw7wgfy'
}];
export function Thanks() {
  useEffect(() => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'Schedule');
    }
  }, []);
  return <PageTransition data-id="element-163">
      <BrandHeader data-id="element-164" />
      <main className="flex-1 w-full max-w-[860px] mx-auto px-4 pb-24 pt-4 flex flex-col items-center" data-id="element-165">
        <div className="text-center mb-8" data-id="element-166">
          <h2 className="font-display font-extrabold text-[22px] text-danger mb-2" data-id="element-167">
            DISCLAIMER:{' '}
            <span className="text-ink" data-id="element-168">Your call is NOT confirmed.</span>
          </h2>
          <p className="font-sans font-medium text-[16px] text-ink-soft" data-id="element-169">
            Watch the short video below for{' '}
            <span className="underline decoration-orange decoration-2 underline-offset-4" data-id="element-170">
              2 quick steps
            </span>{' '}
            to lock in your spot
          </p>
        </div>

        <div className="w-full mb-16" data-id="element-171">
          <WistiaPlayer mediaId="8cdlaagohd" data-id="element-172" />
        </div>

        <div className="w-full mb-16" data-id="element-173">
          <h3 className="font-display font-bold text-[24px] text-ink mb-4" data-id="element-174">
            Here's what we'll do on your 30-minute Zoom call:
          </h3>
          <OrangeAccent className="mb-8" data-id="element-175" />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-176">
            <div className="space-y-4" data-id="element-177">
              <div className="flex gap-3" data-id="element-178">
                <span className="text-xl" data-id="element-179">🧠</span>
                <p className="font-sans text-[15px] text-ink-soft leading-relaxed" data-id="element-180">
                  Look at your real numbers: last month's revenue, active
                  patients, incomplete care plans
                </p>
              </div>
              <div className="flex gap-3" data-id="element-181">
                <span className="text-xl" data-id="element-182">🧠</span>
                <p className="font-sans text-[15px] text-ink-soft leading-relaxed" data-id="element-183">
                  Map a 90-day Patient Profit System Install to help you build
                  deeper relationships with new and existing patients at scale
                </p>
              </div>
            </div>
            <div className="space-y-4" data-id="element-184">
              <div className="flex gap-3" data-id="element-185">
                <span className="text-xl" data-id="element-186">📊</span>
                <p className="font-sans text-[15px] text-ink-soft leading-relaxed" data-id="element-187">
                  A Google Calendar invite with your Zoom link has been sent to
                  your email.
                </p>
              </div>
              <div className="flex gap-3" data-id="element-188">
                <span className="text-xl" data-id="element-189">📊</span>
                <p className="font-sans text-[15px] text-ink-soft leading-relaxed" data-id="element-190">
                  Open it now and make sure the time & time zone are correct.
                </p>
              </div>
              <div className="flex gap-3" data-id="element-191">
                <span className="text-xl" data-id="element-192">📊</span>
                <p className="font-sans text-[15px] text-ink-soft leading-relaxed" data-id="element-193">
                  Didn't get it? Text "ZOOM" to 775-593-7022 and we'll resend
                  your link.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full bg-white border border-line rounded-[16px] p-6 md:p-8 mb-20" data-id="element-194">
          <h4 className="font-display font-bold text-[18px] text-ink mb-4 flex items-center gap-2" data-id="element-195">
            <span data-id="element-196">✏️</span> Quick prep (60 seconds, optional but powerful):
          </h4>
          <ul className="list-disc list-inside font-sans text-[15px] text-ink-soft space-y-2 ml-1" data-id="element-197">
            <li data-id="element-198">Last month's revenue</li>
            <li data-id="element-199">Approximate active patient count</li>
            <li data-id="element-200">We'll plug those into your plan on the call.</li>
          </ul>
        </div>

        <div className="w-full mb-20" data-id="element-201">
          <h3 className="font-display font-bold text-[24px] text-ink mb-4 text-center" data-id="element-202">
            Frequently Asked Questions
          </h3>
          <OrangeAccent className="mb-10 mx-auto" data-id="element-203" />

          <div className="space-y-10" data-id="element-204">
            {FAQS.map(faq => <div key={faq.mediaId} className="w-full bg-white border border-line rounded-[16px] p-5 md:p-6" data-id="element-205">
                <h4 className="font-display font-bold text-[18px] text-ink mb-4" data-id="element-206">
                  {faq.q}
                </h4>
                <WistiaPlayer mediaId={faq.mediaId} data-id="element-207" />
              </div>)}
          </div>
        </div>
      </main>

      {/* Shared Client Results video grid (full-width like the rest of the funnel) */}
      <ClientResults data-id="element-208" />

      <footer className="font-sans font-medium text-[12px] text-ink-light text-center pb-8" data-id="element-209">
        Terms of Use · Privacy Policy
      </footer>
    </PageTransition>;
}